import { Info } from 'lucide-react';
import { SimpleTooltip } from './tooltip';
import { ReactNode } from 'react';
import { TooltipContentProps } from '@radix-ui/react-tooltip';

interface HelpIconProps {
  content: ReactNode;
  size?: number;
  side?: TooltipContentProps['side'];
}

function HelpIcon({ content, size = 18, side = 'right' }: HelpIconProps) {
  return (
    <SimpleTooltip content={content} side={side}>
      <Info
        size={size}
        className="prompt-safe-com-semantic-small text-prompt-safecomabbey"
      />
    </SimpleTooltip>
  );
}

export default HelpIcon;
